import { useLocation } from '@reach/router';
import PropTypes from 'prop-types';
import React from 'react';
import Helmet from 'react-helmet';

const SEO = ({
  description,
  lang,
  meta,
  keywords,
  title,
  author,
  imageUrl,
}) => {
  const location = useLocation();
  const slug = location.pathname;

  return (
    <Helmet
      htmlAttributes={{
        lang,
        translate: 'no',
      }}
      title={title}
      titleTemplate={title}
      link={[{ rel: 'canonical', href: `https://ifdesign.com${slug}` }]}
      meta={[
        {
          'http-equiv': 'Content-Type',
          content: 'text/html; charset=UTF-8',
        },
        {
          name: `description`,
          content: description,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:image`,
          content: imageUrl,
        },
        {
          property: `og:description`,
          content: description,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:creator`,
          content: author,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: description,
        },
        {
          name: `facebook-domain-verification`,
          content: `0a4qqe28z003b6013p8mtoidvpi4oy`,
        },
        {
          name: `google`,
          content: `notranslate`,
        },
      ]
        .concat(
          keywords.length > 0
            ? {
                name: `keywords`,
                content: keywords.join(`, `),
              }
            : []
        )
        .concat(meta)}
    />
  );
};

SEO.defaultProps = {
  lang: 'en',
  meta: [],
  keywords: [],
  description: '',
};

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  keywords: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string.isRequired,
};

export default SEO;
